import { Box, Stack } from '@mui/material';
import { Cell, Section, Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const RitualHeaderBannerSkeleton: FC = () => (
    <Box
        sx={{
            borderRadius: '16px',
            padding: '20px',
            margin: '0 16px 16px',
            backgroundColor: 'var(--tg-theme-section-bg-color)',
        }}
    >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" alignItems="center" gap={1.5}>
                <ThemedSkeleton variant="circular" width={28} height={28} />
                <Stack direction="column" gap={0.5}>
                    <ThemedSkeleton variant="rectangular" width={150} height={24} sx={{ borderRadius: 1 }} />
                    <ThemedSkeleton variant="rectangular" width={200} height={16} sx={{ borderRadius: 1 }} />
                </Stack>
            </Stack>
            <Stack alignItems="flex-end" gap={0.5}>
                <ThemedSkeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
                <ThemedSkeleton variant="rectangular" width={80} height={14} sx={{ borderRadius: 1 }} />
            </Stack>
        </Stack>
    </Box>
);

export const RitualTasksListSkeleton: FC = () => (
    <Stack sx={{ flex: 1, overflow: 'auto', padding: '0 16px' }}>
        <Section
            header={
                <Section.Header>
                    <Text style={{ fontSize: '13px', fontWeight: 600, color: 'var(--tgui--hint_color)' }}>
                        TODAY'S RITUAL
                    </Text>
                </Section.Header>
            }
        >
            {[1, 2, 3].map((index) => (
                <Cell
                    key={index}
                    style={{
                        padding: '10px 16px',
                        minHeight: '44px',
                    }}
                >
                    <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                        <ThemedSkeleton variant="rectangular" width={200} height={20} sx={{ borderRadius: 1 }} />
                        <ThemedSkeleton variant="circular" width={24} height={24} />
                    </Stack>
                </Cell>
            ))}
        </Section>
    </Stack>
);

export const RitualPageSkeleton: FC = () => (
    <Page back={true} insetEnabled={false}>
        <Stack height="100%" sx={{ background: 'var(--tgui--secondary_bg_color)', paddingTop: 'var(--tg-viewport-content-safe-area-inset-top, 0px)' }}>
            <RitualHeaderBannerSkeleton />
            <RitualTasksListSkeleton />
        </Stack>
    </Page>
);
